var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderSiders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1563_737)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 40,
    r: 29,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1754 37.1713V29.9067C54.1274 29.5222 54.8005 28.5916 54.8005 27.4996C54.8005 26.0625 53.6375 24.8999 52.2004 24.8999C50.7656 24.8999 49.6003 26.0625 49.6003 27.4996C49.6003 28.5916 50.2734 29.521 51.2254 29.9067V34.7462C48.4299 31.8735 44.6594 30.0998 40.5004 30.0998C36.3414 30.0998 32.5725 31.8735 29.7754 34.7474V29.9067C30.7274 29.521 31.4001 28.5916 31.4001 27.4996C31.4001 26.0625 30.2372 24.8999 28.8004 24.8999C27.3652 24.8999 26.2007 26.0625 26.2007 27.4996C26.2007 28.5916 26.8734 29.521 27.8254 29.9067V37.1724C25.9916 39.9422 24.9004 43.3297 24.9004 46.9996C24.9004 52.0271 31.8853 56.0999 40.5004 56.0999C49.1182 56.0999 56.1004 52.0271 56.1004 46.9996C56.1004 43.3282 55.0084 39.9422 53.1754 37.1713ZM40.5004 49.5994C35.1133 49.5994 30.7504 48.4356 30.7504 46.9996C30.7504 43.9526 31.4945 41.1953 32.7004 39.1996C37.9053 40.9972 43.4862 40.8677 48.3004 39.1996C49.5067 41.1953 50.2504 43.953 50.2504 46.9996C50.2504 48.4356 45.8847 49.5994 40.5004 49.5994Z",
    fill: "url(#paint0_linear_1563_737)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0001 45.375C47.0001 46.274 46.274 46.9998 45.375 46.9998C44.4761 46.9998 43.7499 46.274 43.7499 45.375C43.7499 44.4769 44.4761 43.7495 45.375 43.7495C46.274 43.7495 47.0001 44.4769 47.0001 45.375Z",
    fill: "url(#paint1_linear_1563_737)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2495 45.375C37.2495 46.274 36.5229 46.9998 35.6247 46.9998C34.7266 46.9998 34 46.274 34 45.375C34 44.4769 34.7266 43.7495 35.6247 43.7495C36.5229 43.7495 37.2495 44.4769 37.2495 45.375Z",
    fill: "url(#paint2_linear_1563_737)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1563_737",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1563_737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1563_737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1563_737",
    x1: 40.5004,
    y1: 24.8999,
    x2: 40.5004,
    y2: 56.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1563_737",
    x1: 45.375,
    y1: 43.7495,
    x2: 45.375,
    y2: 46.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1563_737",
    x1: 35.6247,
    y1: 43.7495,
    x2: 35.6247,
    y2: 46.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSiders);
export default __webpack_public_path__ + "static/media/header_siders.8618fdf75394421f269ff348141a6811.svg";
export { ForwardRef as ReactComponent };